<template>
  <div class="newsdetail-container">
    <top-nav :shrinked="true"/>
    <div class="content">
      <div class="detail-date">
        <span>{{dataInfo.createTime}}</span>
      </div>
      <div class="detail-title">
        <span>{{dataInfo.title}}</span>
      </div>
      <div class="detail-line"></div>
      <div class="detail-content" v-html="dataInfo.content">

      </div>
      <div class="detail-pre-next">
        <div class="ellipsis" :class="{'not-content':notPre}" @click="lastClick">上一篇：{{dataInfo.lastTitle}}</div>
        <div class="ellipsis" :class="{'not-content':notNext}" @click="nextClick">下一篇：{{dataInfo.nextTitle}}</div>
      </div>
    </div>

  </div>
</template>

<script>
  import topNav from '@/components/base/top-nav'
  import {fetchDetail} from '@/api/news.js'
  import {formatTime} from '@/utils';
  export default {
    name: "detail",
    components:{
      topNav
    },
    data() {
      return {
        id:'',
        type:'',
        dataInfo: {},
        notPre:false,
        notNext:false,
      }
    },
    mounted() {
      this.id = this.$route.query.id
      if(this.$route.query.type){
        this.type = this.$route.query.type
      }
      this.fetchData()
    },
    methods: {
      fetchData(){
        this.notPre = false
        this.notNext = false
        fetchDetail({id:this.id,type:this.type}).then(res=>{
            this.$nextTick(() => {
              // 假设你想要在组件挂载后更改标题
              let title = res.data.title
              // if(title != '嘉宏集团'){
              //   title = title + '_嘉宏集团'
              // }
              document.title = title
              // 设置og:description的内容
              // const description = "这是我的页面描述";
              // const meta = document.querySelector('meta[property="og:description"]');
              // if (meta) {
              //   meta.setAttribute('content', description);
              // } else {
              //   // 如果不存在，则创建一个新的meta标签
              //   const meta = document.createElement('meta');
              //   meta.setAttribute('property', 'og:description');
              //   meta.setAttribute('content', description);
              //   document.head.appendChild(meta);
              // }
            });
            this.dataInfo = res.data
            this.dataInfo.createTime = formatTime(this.dataInfo.createTime,'yyyy-MM-dd')
            if(null==this.dataInfo.nextId){
              this.notNext = true
            }
            if(null==this.dataInfo.lastId){
              this.notPre = true
            }
        })
      },
      lastClick(){
        if(this.dataInfo.lastId){
          this.id = this.dataInfo.lastId
          this.fetchData()
        }
      },
      nextClick(){
        if(this.dataInfo.nextId){
          this.id = this.dataInfo.nextId
          this.fetchData()
        }
      }
    }
  }
</script>

<style>
  @import "../../styles/newsdetail.css";
</style>
